export const logToConsole = ({ severity, message }) => {
    if (severity && message) {
        switch (severity.toLocaleLowerCase()) {
            case 'error':
                console.error(message);
                break;
            case 'warn':
                console.warn(message);
                break;
            case 'info':
                console.log(message);
                break;
            default:
                console.warn('Unrecognized info');
                break;
        }
    }
};
//# sourceMappingURL=logToConsole.js.map